<template>
  <div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-4">
                    <div><label>Games</label></div>
                    <a-select
                      mode="multiple"
                      style="width: 100%"
                      v-model:value="selects.game"
                      placeholder="เลือกเกม"
                      :options="selects.games"
                    />
                  </div>
                  <div class="col-md-4">
                    <div><label>Packages</label></div>
                    <a-input
                      v-model:value="package"
                      placeholder="ค้นหา packages"
                      v-on:keyup.enter="getBenefit()"
                      allow-clear
                    />
                  </div>

                  <div class="col-md-2">
                    <div><label style="color: transparent">ค้นหา</label></div>
                    <a-button type="primary" @click="getBenefit()">
                      ค้นหา
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card-body"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="card-header">
                <h4 class="card-title">รายการ Benefits</h4>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <a-table
                      :columns="columns"
                      :data-source="data"
                      :loading="dataLoaded"
                      bordered
                      size="middle"
                      :scroll="{ x: columnsWidth }"
                    >
                      <template #action="{ record }">
                        <a href="#" @click="showModal(record.id)">แก้ไข</a>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess === false">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <a-result
              status="403"
              title="403"
              sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
            >
              <template #extra>
                <a-button type="primary" @click="goToHome"
                  >กลับหน้าหลัก</a-button
                >
              </template>
            </a-result>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      destroyOnClose="true"
      v-model:visible="visible"
      title="แก้ไขส่วนลด Agent - เติมเกม"
      @ok="handleOk"
      :confirm-loading="confirmLoading"
    >
      <div class="row">
        <div class="col-4">
          <p>ชื่อเกม</p>
        </div>
        <div class="col-8">
          <p>{{ modalBenefit.game }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>ชื่อแพ็คเกจ</p>
        </div>
        <div class="col-8">
          <p>{{ modalBenefit.package }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>Package Id</p>
        </div>
        <div class="col-8">
          <p>{{ modalBenefit.packageId }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>ราคาขาย</p>
        </div>
        <div class="col-8">
          <p>{{ modalBenefit.price }}</p>
        </div>
      </div>
      <div
        class="row mb-20"
        v-for="detail in modalBenefit.details"
        :key="detail.id"
      >
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <a-divider>{{ detail.name }}</a-divider>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <p>ส่วนลด</p>
              <a-input-number
                v-model:value="detail.discount"
                :min="0"
                :max="500"
              />
            </div>
            <div class="col-4 text-center">
              <p>ราคาขาย</p>
              <p>{{ modalBenefit.price - detail.discount }}</p>
            </div>
            <div class="col-4 text-center">
              <p>สถานะ</p>
              <a-switch
                checked-children="ใช้งาน"
                un-checked-children="ไม่ใช้งาน"
                v-model:checked="detail.isActived"
              />
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as configuration from "../../../middleware/configuration";
import * as gameservice from "../../../services/game";
import * as paymentservice from "../../../services/payment";
import { message } from "ant-design-vue";
const key = "updatable";

const columns = [
  {
    title: "ชื่อเกม",
    dataIndex: "game",
    key: "game",
    width: 200,
  },
  {
    title: "ชื่อ Package",
    dataIndex: "package",
    key: "package",
    width: 200,
  },
  {
    title: "ราคาขาย",
    dataIndex: "price",
    key: "price",
    align: "center",
  },
];
export default {
  methods: {
    async getGames() {
      let res = await gameservice.get("games");
      this.selects.games = res.data.map((x) => {
        return { value: x.id, label: x.name };
      });
    },
    async getBenefit() {
      this.dataLoaded = true;
      this.columns = columns.map((x) => x);
      let req = {
        games: this.selects.game,
        package: this.package,
      };
      try {
        let res = await paymentservice.getBenefitGameTopup(req);
        let p_first = res.data.find((x) => x !== undefined);
        if (p_first) {
          p_first.details.map((x) => {
            this.columns.push({
              title: x.name,
              children: [
                {
                  title: "ส่วนลด",
                  dataIndex: "discount_" + x.id,
                  key: "discount_" + x.id,
                  align: "center",
                },
                {
                  title: "ราคาขาย (บาท)",
                  dataIndex: "priceafterdiscount_" + x.id,
                  key: "priceafterdiscount_" + x.id,
                  align: "center",
                },
                {
                  title: "สถานะ",
                  customRender: (e) => {
                    return e.record["status_" + x.id] ? "ใช้งาน" : "ไม่ใช้งาน";
                  },
                  dataIndex: "status_" + x.id,
                  key: "status_" + x.id,
                  align: "center",
                },
              ],
            });
          });
        }
        this.columns.push({
          title: "Action",
          key: "id",
          align: "center",
          slots: { customRender: "action" },
          width: 120,
        });
        let data = res.data;
        data.map((x) => {
          x.details.map((d) => {
            d.uid = this.uid;
            d.packageId = x.packageId;
            x["discount_" + d.id] = d.discount;
            x["priceafterdiscount_" + d.id] = x.price - d.discount;
            x["status_" + d.id] = d.isActived;
          });
        });
        this.data = data;
        this.columnsWidth = 400 * p_first.details.length;
      } catch (error) {
      } finally {
        this.dataLoaded = false;
      }
    },
    showModal(id) {
      let data = this.data.find((x) => x.id === id);
      if (data) {
        this.modalBenefit = data;
      }
      this.visible = true;
    },
    async handleOk() {
      let req = this.modalBenefit.details;
      try {
        let res = await paymentservice.saveBenefitGameTopup(req);
        if (res.data) {
          message.success({
            content: "บันทึกข้อมูลสำเร็จ!",
            key,
            duration: 2,
          });
          this.visible = false;
        }
      } catch (error) {
        message.error({
          content: "บันทึกข้อมูลไม่สำเร็จ กรุณาลองอีกครั้ง!",
          key,
          duration: 2,
        });
      } finally {
        await this.getBenefit();
      }
    },
  },
  data() {
    return {
      uid: "",
      columns: columns,
      columnsWidth: 1000,
      visible: false,
      package: "",
      data: [],
      dataLoaded: false,
      canAccess: null,
      modalBenefit: {
        game: "",
        package: "",
        packageId: 0,
        price: 0,
        details: [],
      },
      selects: {
        game: [],
        games: [],
      },
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let user = await configuration.getIdTokenResult();
    if (user) {
      this.role = user.claims.role;
      if (this.role === "manager" || this.role === "admin") {
        this.canAccess = true;
        await this.getGames();
      } else {
        this.canAccess = false;
      }
    }
  },
};
</script>

<style>
</style>